(() => {
  'use strict';

  const ROOT_SELECTOR = '#prvw__bundle_container';
  const OPTION_SELECTOR =
    '.custom_variant_select_options_list > [data-option-value-id]';
  const SOLD_OUT_CLASS = 'cuddypup-pumper-option--sold-out';
  const SOLD_OUT_LABEL = 'Out of stock';

  let unavailableByOption = null;
  let applyQueued = false;

  const normalize = (value) => String(value || '').trim().toLocaleLowerCase();

  function productJsonUrl() {
    const canonical = document.querySelector('link[rel="canonical"]')?.href;
    const url = new URL(canonical || window.location.href);
    url.search = '';
    url.hash = '';
    url.pathname = `${url.pathname.replace(/\/$/, '')}.js`;
    return url.toString();
  }

  async function loadUnavailableOptions() {
    const response = await fetch(productJsonUrl(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) {
      throw new Error(`Product availability request failed: ${response.status}`);
    }

    const product = await response.json();
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const options = Array.isArray(product.options) ? product.options : [];
    const result = new Map();

    options.forEach((option, optionIndex) => {
      const optionName = typeof option === 'string' ? option : option?.name;
      if (!optionName) return;

      const values = new Set(
        variants
          .map((variant) => normalize(variant.options?.[optionIndex]))
          .filter(Boolean),
      );

      const unavailable = new Set(
        [...values].filter(
          (value) =>
            !variants.some(
              (variant) =>
                variant.available === true &&
                normalize(variant.options?.[optionIndex]) === value,
            ),
        ),
      );

      result.set(normalize(optionName), unavailable);
    });

    return result;
  }

  function setUnavailableState(item, unavailable) {
    item.classList.toggle(SOLD_OUT_CLASS, unavailable);

    if (unavailable) {
      item.setAttribute('aria-disabled', 'true');
      item.setAttribute('title', SOLD_OUT_LABEL);
    } else {
      item.removeAttribute('aria-disabled');
      if (item.getAttribute('title') === SOLD_OUT_LABEL) {
        item.removeAttribute('title');
      }
    }
  }

  function applyAvailability() {
    applyQueued = false;
    if (!unavailableByOption) return;

    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;

    const onlyOption =
      unavailableByOption.size === 1
        ? unavailableByOption.values().next().value
        : null;

    root.querySelectorAll(OPTION_SELECTOR).forEach((item) => {
      const wrapper = item.closest('.custom_variant_select_wrapper_main');
      const optionName = normalize(wrapper?.dataset.optionName);
      const unavailableValues = unavailableByOption.get(optionName) || onlyOption;
      const valueElement = item.querySelector(':scope > div');
      const value = normalize(valueElement?.textContent || item.textContent);

      setUnavailableState(item, Boolean(unavailableValues?.has(value)));
    });
  }

  function queueApply() {
    if (applyQueued) return;
    applyQueued = true;
    queueMicrotask(applyAvailability);
  }

  function blockUnavailableSelection(event) {
    const item = event.target.closest?.(`.${SOLD_OUT_CLASS}`);
    if (!item) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  function observePumper() {
    const root = document.querySelector(ROOT_SELECTOR);

    if (!root) {
      const pageObserver = new MutationObserver(() => {
        if (document.querySelector(ROOT_SELECTOR)) {
          pageObserver.disconnect();
          observePumper();
        }
      });
      pageObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
      return;
    }

    applyAvailability();

    const pumperObserver = new MutationObserver(queueApply);
    pumperObserver.observe(root, {
      childList: true,
      subtree: true,
    });
  }

  async function init() {
    try {
      unavailableByOption = await loadUnavailableOptions();
      observePumper();
    } catch (error) {
      console.warn('[Cuddypup] Pumper availability enhancement skipped.', error);
    }
  }

  document.addEventListener('click', blockUnavailableSelection, true);
  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        blockUnavailableSelection(event);
      }
    },
    true,
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
